import React, {Component} from 'react';

import { connect } from 'react-redux'
import UnpaidCloses from './components/UnpaidCloses/UnpaidCloses'

import {
  fetchSlimAccount, fetchUnpaidCloses
} from 'broker/redux/account'
import {UNIVERSAL_EXPORT_TIMEFRAME_ALL_TIME} from 'common/constants'
import {getAuthEmail} from "broker/util/downloader";

const mapDispatchToProps = dispatch => ({
  dispatch
})

class UnpaidClosesContainer extends Component {

  constructor(props) {
    super(props)
  }

  componentWillMount() {
    const { dispatch, account } = this.props

    dispatch(fetchUnpaidCloses(UNIVERSAL_EXPORT_TIMEFRAME_ALL_TIME, false,null))
    dispatch(fetchSlimAccount())
  }

  render() {
    return <UnpaidCloses {...this.props} />
  }
}

export default connect((state) => ({ account: state.account, auth: state.auth, email: getAuthEmail(state), root: state.root }), mapDispatchToProps)(UnpaidClosesContainer)
